<template>
    <!-- eslint-disable vue/no-v-html -->
    <div class="vqb-rule card">
        <div class="form-inline d-flex justify-space-between">
            <div class="d-flex align-center">
                <v-text-field
                    class="vqb-field mr-6"
                    v-model="rule.label"
                    disabled
                    :label="tb('Nome do campo')"
                    dense
                    hide-details
                >
                </v-text-field>

                <!-- List of operators (e.g. =, !=, >, <) -->
                <!-- Multiple operators -->
                <v-select
                    class="vqb-field mr-6"
                    v-if="
                        (typeof rule.operators) !== 'undefined' &&
                        rule.operators.length >= 1
                    "
                    v-model="query.operator"
                    :items="rule.operators"
                    dense
                    :label="$t('queryBuilder.operator')"
                    :disabled="rule.operators.length >= 1 ? false : true"
                    hide-details
                >
                </v-select>


                <!-- Basic text input -->
                <v-text-field
                    class="vqb-field mr-6"
                    v-if="rule.type === 'text' && query.operator != 'não está vazio' && query.operator != 'está vazio'"
                    v-model="query.value"
                    dense
                    :label="tb('Valor')"
                    hide-details
                >
                </v-text-field>

                <!-- Basic number input -->
                <v-text-field
                    class="vqb-field mr-6"
                    v-if="rule.type === 'number'"
                    v-model.number="query.value"
                    dense
                    :label="tb('Valor numérico')"
                    type="number"
                    hide-details
                >
                </v-text-field>

                <!-- Boolean -->
                <v-checkbox
                    class="vqb-field mr-6 ml-n1"
                    v-if="rule.type === 'boolean'"
                    :false-value="0"
                    :true-value="1"
                    v-model="query.value"
                    type="checkbox"
                    :label="`${query.value == '1' ? $t('common.yes') : $t('common.no')}`"
                    dense
                    hide-details
                >
                </v-checkbox>
            </div>


            <div class="d-flex align-center">
                <!-- Remove rule button -->
                <button
                    type="button"
                    class="close ml-auto"
                    @click="remove"
                    v-html="labels.removeRule"
                ></button>
            </div>
        </div>
    </div>
</template>

<script>
import QueryBuilderRule from "vue-query-builder/dist/rule/QueryBuilderRule.umd";

export default {
    extends: QueryBuilderRule,
    created() {
        if (this.rule.type == "boolean") {
            this.query.value = 1;
        }
    },

    watch: {
        'query.operator'(newValue) {
            if (newValue ==  "não está vazio" || newValue == "está vazio") {
                this.query.value = null;
            }
        }
    }
};
</script>

<style scoped>
.vqb-field {
    max-width: 200px;
}
</style>
